<!-- Welcome -->
<div class="welcome-card">
    <div>
        <h2 style="font-weight: normal;">Welcome Back, <span style="font-weight: 600;">{{user.name}}</span>
            ({{user.position}})</h2>
        <p>Manage your classes, students, attendance and assignments efficiently.</p>
    </div>

    <!-- <button class="btn btn-primary">
        <i class="bi bi-plus-circle"></i>
        Create Assignment
    </button> -->
</div>

<!-- Statistics -->
<div class="row g-3 mt-0">
    <div class="col-lg-3 col-md-6">
        <div class="stat-card">
            <div class="stat-icon blue">
                <i class="bi bi-people"></i>
            </div>
            <div>
                <h3>{{tot_std}}</h3>
                <p>Total Students</p>
                <div class="growth up">
                    <i class="bi bi-arrow-up"></i>
                    +0% this month
                </div>
            </div>
        </div>
    </div>

    <div class="col-lg-3 col-md-6">
        <div class="stat-card">
            <div class="stat-icon green">
                <i class="bi bi-person-badge"></i>
            </div>
            <div>
                <h3>{{tot_staff}}</h3>
                <p>Total Teachers</p>
                <div class="growth up">
                    <i class="bi bi-arrow-up"></i>
                    +0% this month
                </div>
            </div>
        </div>
    </div>

    <div class="col-lg-3 col-md-6">
        <div class="stat-card">
            <div class="stat-icon orange">
                <i class="bi bi-cash-stack"></i>
            </div>
            <div>
                <h3>₹8.2L</h3>
                <p>Monthly Revenue</p>
                <div class="growth up">
                    <i class="bi bi-arrow-up"></i>
                    +18% this month
                </div>
            </div>
        </div>
    </div>

    <div class="col-lg-3 col-md-6">
        <div class="stat-card">
            <div class="stat-icon red">
                <i class="bi bi-calendar-check"></i>
            </div>
            <div>
                <h3>94%</h3>
                <p>Attendance Rate</p>
                <div class="growth down">
                    <i class="bi bi-arrow-down"></i>
                    -2% this week
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row g-3 mt-1">
    <div class="col-lg-8">
        <div class="tdashboard-card h-100">
            <div class="card-header-custom">
                <div>
                    <h5>School Revenue Analytics</h5>
                    <small class="text-muted">
                        Monthly collection overview
                    </small>
                </div>
                <select class="form-select form-select-sm chart-filter">
                    <option>2026</option>
                    <option>2025</option>
                </select>
            </div>

            <apx-chart
            [series]="series1"
            [chart]="chart1"
            [xaxis]="xaxis1"
            [dataLabels]="dataLabels1"
            ></apx-chart>
        </div>
    </div>

    <div class="col-lg-4">
        <div class="tdashboard-card h-100">
            <div class="card-header-custom">
                <h5>Attendance</h5>
            </div>

            <apx-chart
            [series]="series2"
            [chart]="chart2"
            [labels]="labels2"
            [legend]="legend2"
            [colors]="colors2"
            ></apx-chart>
        </div>
    </div>
</div>

<div class="row g-3 mt-1">
    <div class="col-lg-6">
        <div class="tdashboard-card h-100">
            <div class="card-header-custom">
                <h5>Student Growth</h5>
            </div>
            <apx-chart
            [series]="series3"
            [chart]="chart3"
            [xaxis]="xaxis3"
            ></apx-chart>
        </div>
    </div>

    <div class="col-lg-6">
        <div class="tdashboard-card h-100">
            <div class="card-header-custom">
                <h5>Fee Collection Status</h5>
            </div>
            <apx-chart
            [series]="series4"
            [chart]="chart4"
            [labels]="labels4"
            [colors]="colors4"
            ></apx-chart>
        </div>
    </div>
</div>

<div class="row g-3 mt-1">
    <div class="col-lg-4">
        <div class="tdashboard-card h-100">
            <div class="card-header-custom">
                <h5>Quick Actions</h5>
            </div>

            <div class="quick-actions">
                <button class="quick-btn">
                    <i class="bi bi-person-plus"></i>
                    Add Student
                </button>

                <button class="quick-btn">
                    <i class="bi bi-person-workspace"></i>
                    Add Teacher
                </button>

                <button class="quick-btn">
                    <i class="bi bi-envelope-paper"></i>
                    Send Circular
                </button>

                <button class="quick-btn">
                    <i class="bi bi-file-earmark-bar-graph"></i>
                    Reports
                </button>

                <button class="quick-btn">
                    <i class="bi bi-calendar-event"></i>
                    Events
                </button>

                <button class="quick-btn">
                    <i class="bi bi-megaphone"></i>
                    Announcements
                </button>
            </div>
        </div>
    </div>

    <div class="col-lg-8">
        <div class="tdashboard-card h-100">
            <div class="card-header-custom">
                <h5>Recent Activities</h5>
            </div>
            <div class="table-responsive">
                <table class="table align-middle">
                    <thead>
                        <tr>
                            <th>Activity</th>
                            <th>User</th>
                            <th>Status</th>
                            <th>Time</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td>Admission Approved</td>
                            <td>Admin Staff</td>
                            <td>
                                <span class="badge bg-success">
                                    Completed
                                </span>
                            </td>
                            <td>10 mins ago</td>
                        </tr>

                        <tr>
                            <td>Exam Schedule Updated</td>
                            <td>Examination Dept.</td>
                            <td>
                                <span class="badge bg-primary">
                                    Published
                                </span>
                            </td>
                            <td>30 mins ago</td>
                        </tr>

                        <tr>
                            <td>Transport Route Modified</td>
                            <td>Transport Manager</td>
                            <td>
                                <span class="badge bg-warning text-dark">
                                    Pending
                                </span>
                            </td>
                            <td>1 hour ago</td>
                        </tr>

                        <tr>
                            <td>Fee Payment Received</td>
                            <td>Accounts Dept.</td>
                            <td>
                                <span class="badge bg-success">
                                    Paid
                                </span>
                            </td>
                            <td>2 hours ago</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
